import React from 'react';

export const NewsIcon = ({ width, height, fill }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 16 16'
      className='icon icon-news'
    >
      <path
        id='Path_482'
        data-name='Path 482'
        className='cls-1'
        fill={fill}
        d='M16.4,2H3.6A1.6,1.6,0,0,0,2.008,3.6L2,18l3.2-3.2H16.4A1.6,1.6,0,0,0,18,13.2V3.6A1.6,1.6,0,0,0,16.4,2ZM6.8,11.6H5.2V10H6.8Zm0-2.4H5.2V7.6H6.8Zm0-2.4H5.2V5.2H6.8Zm5.6,4.8h-4V10h4Zm2.4-2.4H8.4V7.6h6.4Zm0-2.4H8.4V5.2h6.4Z'
        transform='translate(-2 -2)'
      />
    </svg>
  );
};

NewsIcon.defaultProps = {
  width: 16,
  height: 16,
  fill: 'var(--white)'
};